import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';

import "stylesheets/fonts.scss";
import constants from '../../constants';
import './Summary.scss';
import './SummaryShimmer.scss';
import text from '../../../../strings/text';
import { Link } from 'react-router-dom/cjs/react-router-dom';

class Summary extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state ={
      selectedIndex: 0,
      selectedItem: null,
    };

    this._isMounted = false;
  }

  componentDidMount() {
    const { parentSelectedIndex, summaryItems, selectedType, } = this.props;
   
    this._isMounted = true;
    if(parentSelectedIndex !== undefined) {
      if(selectedType === 'LOCATION') {
        this.setState({selectedIndex: parentSelectedIndex});
      }
      if(selectedType === 'GROUPS' || selectedType === 'DEPARTMENTS' || selectedType === 'SKILLS') {
        if(parentSelectedIndex < summaryItems.length) {
          this.setState({selectedIndex: parentSelectedIndex, selectedItem: summaryItems[parentSelectedIndex]});
        }else {
          const firstItem = summaryItems && summaryItems.length > 0 ? summaryItems[0] : null;
          this.setState({selectedIndex: 0, selectedItem: firstItem});
        }
      }
    }
  }

  componentDidUpdate(prevProps, prevState) {
    const { summaryItemSelected, selectedType, summaryItems, parentSelectedIndex } = this.props;
    const { selectedItem, selectedIndex } = this.state;
    const { categoryTypes } = constants;

    if(prevProps.selectedType !== selectedType) {
      const firstItem = summaryItems && summaryItems.length > 0 ? summaryItems[0] : null;
      this.setState({selectedIndex: 0, selectedItem: firstItem});
    }

    if(prevState.selectedItem !== selectedItem) {
      summaryItemSelected(selectedIndex, selectedItem);
    }

    if(prevProps.parentSelectedIndex !== parentSelectedIndex) {
      this.setState({selectedIndex: parentSelectedIndex});
    }


    if(prevProps.summaryItems !== summaryItems) {
      let foundItem = [];
      if(selectedType === categoryTypes.GROUPS) {
        if(summaryItems &&  prevProps.summaryItems && summaryItems.length < prevProps.summaryItems.length) {
          if(selectedItem) {
            foundItem = summaryItems.filter((item) => item.id === selectedItem.id);
            if(foundItem.length === 0) {
              if(selectedIndex < summaryItems.length) {
                this.setState({selectedItem: summaryItems[selectedIndex]});
                summaryItemSelected(selectedIndex, summaryItems[selectedIndex]);
              }else if(selectedIndex === summaryItems.length && summaryItems.length > 0) {
                this.setState({selectedIndex: summaryItems.length - 1, selectedItem: summaryItems[summaryItems.length - 1]});
                summaryItemSelected(summaryItems.length - 1, summaryItems[summaryItems.length - 1]);
              }
            }
          }else {
            if(selectedIndex === summaryItems.length && summaryItems.length > 0) {
              this.setState({selectedIndex: summaryItems.length - 1, selectedItem: summaryItems[summaryItems.length - 1]});
              summaryItemSelected(summaryItems.length - 1, summaryItems[summaryItems.length - 1]);
            }
          }
        }else if(summaryItems && prevProps.summaryItems && summaryItems.length > prevProps.summaryItems.length) {
          if(selectedIndex < summaryItems.length) {
            this.setState({selectedItem: summaryItems[selectedIndex]});
            summaryItemSelected(selectedIndex, summaryItems[selectedIndex]);
          }
        }
      }
    }

  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  handleItemClicked = (e, index, item) => {
    this.setState({selectedIndex: index, selectedItem: item});
  }


  render() {
    const { selectedIndex } = this.state;
    const { summaryItems, handleAddMemberClick } = this.props;

    const renderSummaryElements = () => {
      if (!summaryItems) return null;

      return summaryItems.map((item, index) => {
        const isSelected = (selectedIndex === index);
        const className = "caption-item" + (isSelected ? ' item-selected' : '');

        return (
          <div className={className} key={index} id={index} onClick={(e) => this.handleItemClicked(e, index, item)} >
            <div className="semibold-14">{item.name}</div>
          </div>
        );
      });
    };

    return (
      <div className="caption-container">
        <div className="section-left">{renderSummaryElements()}</div>
        <div className="section-right semibold-14">
          <Link className="line-btn" to="/roles"> {text.rolesAndSkills} 
            <span className="beta-tag">BETA</span>
          </Link>
          <button className="add-member-button role-and-skill" onClick={handleAddMemberClick}>
            {text.addTeamMember}
          </button>
        </div>
      </div>
    );
  }

}

Summary.propTypes = {
  summaryItems: PropTypes.array.isRequired,
  selectedType: PropTypes.string.isRequired,
  summaryItemSelected: PropTypes.func.isRequired,
};

export default injectIntl(Summary);

